<template>
  <div class="table-responsive col-lg-12 ibox-content" v-if="task">
    <modal-form modal-id="add-comment">
      <div slot="title">Add Comment</div>
      <div slot="form">
        <div class="col-lg-12 m-t-xs">
          <input type="text" v-model="comment['title']" class="form-control" placeholder="Title" />
        </div>
        <div class="col-lg-12 m-t-xs">
          <textarea v-model="comment['message']" rows="10" class="form-control" placeholder="Message"></textarea>
        </div>
        <div class="col-lg-12 m-t-xs">
          <button class="btn btn-xs btn-primary" @click="addComment"><i class="fa fa-plus"></i> Add</button>
        </div>
      </div>
    </modal-form>
    <div class="ibox">
      <div class="col-lg-4">
        <table class="table table-hover" v-if="pbn">
          <thead>
          <tr>
            <th colspan="2">
              <form method="POST" :action="'https://' + pbn.domain + '/wp-aphex.php?act=admin-login'" target="_blank"  v-if="pbn.hasAphexManager" style="margin: 0; padding: 0;">
                <input type="hidden" name="authorization" value="20xehpa19">
                <button class="btn btn-xs btn-success pull-right"><i class="fa fa-key"></i> Login</button>
              </form>
              Pbn
            </th>
          </tr>
          </thead>
          <tbody>
          <tr>
            <td colspan="2">
              <router-link :to="'/pbn/' + pbn.punyDomain">{{ pbn.domain }}</router-link>
              <a :href="'https://' + pbn.domain" target="_blank"><i class="fa fa-external-link"></i></a>
              <a :href="'https://' + pbn.domain + '/wp-admin'" target="_blank" title="/wp-admin"><i class="fa fa-lock"></i></a>
            </td>
          </tr>
          <tr>
            <td>Type:</td>
            <td>{{ pbn.type }}</td>
          </tr>
          <tr>
            <td>Status:</td>
            <td>{{ pbn.status }}</td>
          </tr>
          <tr v-if="pbn.logins && pbn.logins.length">
            <td>User:</td>
            <td>{{ pbn.logins[0].username }}</td>
          </tr>
          <tr v-if="pbn.logins && pbn.logins.length">
            <td>Pass:</td>
            <td>{{ pbn.logins[0].password }}</td>
          </tr>
          <tr>
            <td>Posts:</td>
            <td>
              <span v-if="pbn.content">
              {{ pbn.content.contentCount || 0 }}
              </span>
              <span v-else>?</span>
            </td>
          </tr>
          <tr>
            <td>Last post update:</td>
            <td>
              <span v-if="pbn.content && pbn.content.lastUpdate">{{ pbn.content.lastUpdate | aTime('from') }}</span>
            </td>
          </tr>
          </tbody>
          <tbody v-if="pbn.buildInfo">
          <tr>
            <td>Language</td>
            <td>{{ pbn.buildInfo.language || '/' }}</td>
          </tr>
          <tr>
            <td>Topic</td>
            <td>{{ pbn.buildInfo.topic || '/' }}</td>
          </tr>
          <tr>
            <td>Style</td>
            <td>{{ pbn.buildInfo.designStyle || '/' }}</td>
          </tr>
          </tbody>
          <tbody v-if="pbn">
          <tr>
            <td>Hosting:</td>
            <td>{{ pbn.hosting ? pbn.hosting.name : '?' }}</td>
          </tr>
          <tr v-if="pbn.integrations && pbn.integrations.hosting && pbn.integrations.hosting.hostingType">
            <td>Server:</td>
            <td><strong>{{ pbn.integrations.hosting.hostingType === 'SHARED_HOSTING' ? 'Priority Prospect' : 'Digital Ocean' }}</strong></td>
          </tr>
          </tbody>
        </table>
      </div>
      <div class="col-lg-4">
        <table class="table table-hover" v-if="task.qaChecks && task.qaChecks.length">
          <thead>
          <tr>
            <th>QA Info</th>
            <th>Type</th>
            <th><i class="fa fa-remove red"></i></th>
            <th><i class="fa fa-warning orange"></i></th>
            <th><i class="fa fa-check green"></i></th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="check in task.qaChecks" :key="check.id">
            <td>{{ check.time | aTime('DD.MM. HH:mm') }}</td>
            <td>{{ check.type }}</td>
            <td class="red">{{ check.errors.length }}</td>
            <td class="orange">{{ check.warnings.length }}</td>
            <td class="green">{{ check.messages.length }}</td>
          </tr>
          </tbody>
        </table>
      </div>
      <div class="col-lg-4">
        <table class="table table-hover">
          <thead v-if="task.description">
          <tr>
            <th>Description</th>
          </tr>
          </thead>
          <tbody v-if="task.description">
          <tr>
            <td>
              {{ task.description }}
            </td>
          </tr>
          </tbody>
          <thead>
          <tr>
            <th>
              History
              <button class="btn btn-xs pull-right btn-primary" data-toggle="modal" data-target="#add-comment"><i class="fa fa-comment"></i> Add Comment</button>
            </th>
          </tr>
          </thead>
          <tbody v-for="(comment, i) in [...task.comments].reverse()" :key="'comment-' + i">
          <tr>
            <td>
              <i class="fa fa-comment green" v-if="comment.type === 'comment'"></i>
              <i class="fa fa-comment blue" v-if="comment.type === 'action'"></i>
              <i class="fa fa-ban red" v-if="comment.type === 'blocker'"></i>
              {{ comment.user }} @ {{ comment.time | aTime('DD.MM. HH:mm') }} | <strong>{{ comment.title }}</strong>
            </td>
          </tr>
          <tr v-if="comment.message">
            <td>{{ comment.message }}</td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import axios from 'axios'
import { TASK_SET } from '../../../../store/mutation-types'
import Form from '../../../Helpers/Modal/Form'

export default {
  data () {
    return {
      comment: {}
    }
  },
  computed: {
    ...mapGetters({
      task: 'getTask',
      pbn: 'getPbn'
    })
  },
  components: {
    modalForm: Form
  },
  methods: {
    addComment () {
      if (!this.comment.title || !this.comment.message) {
        this.$toastr.error('Please add message and title')
        return
      }
      axios.post(`/maintenance/task/${this.task.id}/comment`, this.comment)
        .then(r => {
          this.$store.commit(TASK_SET, r.data.task)
          $('#add-comment').modal('hide')
          this.comment = {}
        })
        .catch(e => {})
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/MaintenanceOrder/Task/Content.vue